import { render, staticRenderFns } from "./AssignedOrdersReports.vue?vue&type=template&id=c32de836&"
import script from "./AssignedOrdersReports.vue?vue&type=script&lang=js&"
export * from "./AssignedOrdersReports.vue?vue&type=script&lang=js&"
import style0 from "./AssignedOrdersReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports